// @flow
import { restore, Store } from 'effector'
import { mergeDeepRight } from 'ramda'
import { decamelizeString } from 'utils/camelize'
import type { Widget } from '../types'
import { setMounted, setWidgetsTransformed, updateWidget } from './events'

type Widgets = Array<Widget<{ ... }>>

const mounted: Store<boolean> = restore(setMounted, false)
const $widgets: Store<Widgets> = restore(setWidgetsTransformed, [])

$widgets.on(updateWidget, (widgets, payload) => {
  return widgets.map((widget) => {
    if (widget.name === decamelizeString(payload.name).toUpperCase()) return mergeDeepRight(widget, payload.props)

    return widget
  })
})

export { mounted, $widgets }
